import type { ReactElement } from 'react';
import type { DropTarget, Key } from '@react-types/shared';
import { cn } from 'v5/platform/dom/cn';
import { CollectionDropIndicator } from 'v5/patterns/dnd/CollectionDropIndicator';
import {
  dndListGapClassName,
  resolveDndListGapLineClassName,
  type DndListGap
} from 'v5/patterns/dnd/collectionReorder';

export type { DndListGap };
export type DndListRenderDropIndicator = (target: DropTarget) => ReactElement;

const gridDropIndicatorClassName = cn(
  'col-span-full data-drop-target:isolate [&_[role=gridcell]]:relative [&_[role=gridcell]]:z-50 [&_[role=gridcell]]:h-0 [&_[role=gridcell]]:min-h-0 [&_[role=gridcell]]:overflow-visible [&_[role=gridcell]]:p-0'
);

/** Flex column list with `gap-N` on the parent. */
export function flexListDropIndicator(
  gap: DndListGap,
  firstKey?: Key
): DndListRenderDropIndicator {
  return target => (
    <CollectionDropIndicator
      target={target}
      gapClassName={dndListGapClassName[gap]}
      lineClassName={resolveDndListGapLineClassName(gap, target, { firstKey })}
    />
  );
}

/** CSS grid list with `gap-y-0`, `pt-N`, and item `mb-N` spacing. */
export function gridListDropIndicator(
  gap: DndListGap
): DndListRenderDropIndicator {
  return target => (
    <CollectionDropIndicator
      target={target}
      lineClassName={resolveDndListGapLineClassName(gap, target, {
        hasLeadingPadding: true
      })}
      className={gridDropIndicatorClassName}
    />
  );
}
